// extracted by mini-css-extract-plugin
var _1 = "PublicTopicPosts-module__animatedBackground--KdWcY";
var _2 = "PublicTopicPosts-module__container--qRq4A";
export { _1 as "animatedBackground", _2 as "container" }
